const config = {
  env: "local",


  //apiUrl: "http://localhost:5521/admin/",
  //  apiUrl: "http://13.235.246.243:5624/admin/",
  apiUrl:"https://api.ocfitseed.com/admin/",
  shipRocketApiUrl: "https://apiv2.shiprocket.in/v1/external/",
};

export default config;
